import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { Close } from '@liveauctioneers/hammer-ui-core/icons';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { ExternalRouteButton } from '@/components/RouteButton/RouteButton';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getMobileBrowserOS } from '@/redux/modules/browser';
import { getCookie, setCookie } from '@/redux/modules/cookies';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

const COOKIE_MAX_AGE = 86400 * 30; // 30 days
const COOKIE_NAME = 'dismissableMobileBanner';
const COOKIE_BODY = 'dismissed';

export const DismissableGetMobileBanner = () => {
    const dispatch = useAppDispatch();
    const formatMessage = useAppFormatMessage();
    const mobileBrowserOS = useAppSelector(getMobileBrowserOS);
    const { pathname } = useLocation();
    const isCheckoutPage = pathname.includes('/checkout/');
    const biddingConsole = pathname.includes('/console/');
    const dismissed = useAppSelector((state) => getCookie(state, COOKIE_NAME)) === COOKIE_BODY;

    const setCookieChecked = useCallback((): void => {
        dispatch(
            setCookie({
                maxAge: COOKIE_MAX_AGE,
                name: COOKIE_NAME,
                value: COOKIE_BODY,
            })
        );
    }, [dispatch]);

    if (biddingConsole || isCheckoutPage || mobileBrowserOS === '' || dismissed) {
        return null;
    }

    const navTo =
        mobileBrowserOS === 'ios'
            ? 'https://itunes.apple.com/us/app/live-auctions/id321243082'
            : 'https://play.google.com/store/apps/details?id=com.liveauctioneers.and';

    return (
        <div
            className="relative flex h-[63px] w-full items-center justify-around bg-primary-400 pl-sm pr-[36px]"
            id="mobileBanner"
        >
            <img
                alt="mobile"
                className="flex max-h-[42px] max-w-[42px] rounded-[5px]"
                src="https://p1.liveauctioneers.com/dist/images/mobile_icon.png"
            />
            <div className="max-w-[180px] text-center font-secondary text-sm leading-[18px] tracking-[0.5px] text-surface-100">
                {formatMessage(['get_notifications_from_favorite_auctioneers'])}
            </div>
            <ExternalRouteButton
                className="!h-[26px] !w-[76px] !border !border-border-inverse !bg-link-primary !p-0 !text-xs !text-text-inverse"
                rel="nofollow noopener"
                target="_blank"
                to={navTo}
            >
                {formatMessage(['get_app'])}
            </ExternalRouteButton>
            <IconButton
                className="absolute right-xs top-xs z-10"
                icon={Close}
                iconStyle="bold"
                onClick={setCookieChecked}
                size="xs"
                style="inverse"
                variant="transparent"
            />
        </div>
    );
};
